var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_shift_form_newTitle"),
      pad: "0",
      initData: _vm.shiftData,
      checkData: [
        "shift_name",
        "sequence",
        "shift_description",
        "shift_abbr",
        "start_utc_time",
        "end_utc_time",
        "total_working_minutes",
        "color_code",
        "shift_code",
        "default_site_uuid",
        "effective_utc_datetime",
        "expired_utc_datetime",
        "shift_property_group_uuid",
        "remarks",
      ],
      widthClass: "max-1000",
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Stepper", {
              attrs: { curStep: _vm.curStep, items: _vm.stepper },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "pa-2",
                          attrs: { "lazy-validation": "" },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "white lighten-5",
                              attrs: { justify: "start" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      bindData: _vm.shiftData.shift_name,
                                      maxlength: "100",
                                      label: _vm.$t(
                                        "label_essweb_shift_form_shiftNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.shiftData.shift_name = valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      maxlength: "20",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_shift_form_shiftAbbrLabel"
                                      ),
                                    },
                                    model: {
                                      value: _vm.shiftData.shift_abbr,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.shiftData,
                                          "shift_abbr",
                                          $$v
                                        )
                                      },
                                      expression: "shiftData.shift_abbr",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "4",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      label: _vm.$t(
                                        "label_essweb_ClaimReason_form_codeLabel"
                                      ),
                                      maxlength: "100",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules", "_Length_Rules"],
                                        [null, 100]
                                      ),
                                    },
                                    model: {
                                      value: _vm.shiftData.shift_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.shiftData,
                                          "shift_code",
                                          $$v
                                        )
                                      },
                                      expression: "shiftData.shift_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "4",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      label: _vm.$t(
                                        "label_essweb_shift_form_sequenceLabel"
                                      ),
                                      type: "number",
                                      maxlength: "255",
                                      rules: _vm.$GetRules(
                                        ["_Number_negative", "_Length_Rules"],
                                        [null, 255]
                                      ),
                                    },
                                    model: {
                                      value: _vm.shiftData.sequence,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.shiftData, "sequence", $$v)
                                      },
                                      expression: "shiftData.sequence",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "4",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_shift_form_tagColorLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("SelectColor", {
                                    attrs: {
                                      items: _vm.Colors,
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    model: {
                                      value: _vm.shiftData.color_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.shiftData,
                                          "color_code",
                                          $$v
                                        )
                                      },
                                      expression: "shiftData.color_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      bindData: _vm.shiftData.shift_description,
                                      maxlength: "500",
                                      label: _vm.$t(
                                        "label_essweb_shift_form_descriptionLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.shiftData.shift_description =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "px-1",
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("Tabler", {
                                    attrs: {
                                      headers: _vm.headers,
                                      items: _vm.desserts,
                                      border: "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "item.type",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.type
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.name",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text--primary table-title",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$getCommonLangValue(
                                                        item.name
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.startTime",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text--primary table-title",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$timeMachine(
                                                        item.startTime
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.endTime",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text--primary table-title",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$timeMachine(
                                                        item.endTime
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.total",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text--primary table-title",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      Number(item.endTime) -
                                                        Number(item.startTime)
                                                    ) +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "label_essweb_system_minutesLabel"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.group",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toViewProperty(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "material-icons-round",
                                                  },
                                                  [_vm._v("search")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.action",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            false
                                              ? _c(
                                                  "v-btn",
                                                  {
                                                    attrs: { icon: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toEditMapping(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "material-icons-round",
                                                      },
                                                      [_vm._v("edit")]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toDelete(item)
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "material-icons-round",
                                                  },
                                                  [_vm._v("delete")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "footer",
                                        fn: function () {
                                          return [
                                            _c("v-divider"),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass:
                                                  "text-capitalize my-2 text-button",
                                                attrs: {
                                                  text: "",
                                                  small: "",
                                                  color: "primary",
                                                },
                                                on: { click: _vm.toNewMapping },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "label_essweb_shift_form_addEventBtnLabel"
                                                      )
                                                    )
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "material-icons-round",
                                                  },
                                                  [_vm._v("add")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                  }),
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "text--secondary pl-1 text-left",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_shift_form_totalMinutesLabel"
                                          ) + " "
                                        ) +
                                          ":" +
                                          _vm._s(_vm.totalMin) +
                                          _vm._s(
                                            _vm.$t(
                                              "label_essweb_system_minutesLabel"
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("AutoComplete", {
                                    attrs: {
                                      isRequired: "",
                                      items: _vm.ShiftTypeList,
                                      "item-text": "shift_type_name",
                                      label:
                                        "label_essweb_shift_form_shiftTypeLabel",
                                      "item-value": "uuid",
                                      chips: "",
                                      rules: _vm.$GetRules(
                                        ["_Require_ArrRules"],
                                        [null]
                                      ),
                                      multiple: "",
                                      "deletable-chips": "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item.shift_type_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.title",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item.shift_type_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.shiftData.shift_type_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.shiftData,
                                          "shift_type_uuid",
                                          $$v
                                        )
                                      },
                                      expression: "shiftData.shift_type_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("AutoComplete", {
                                    attrs: {
                                      items: _vm.defaultSiteList,
                                      "item-text": "site_name",
                                      label:
                                        "label_essweb_shift_form_siteNameLabel",
                                      "item-value": "uuid",
                                      chips: "",
                                      "deletable-chips": "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item.site_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.title",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item.site_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.shiftData.default_site_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.shiftData,
                                          "default_site_uuid",
                                          $$v
                                        )
                                      },
                                      expression: "shiftData.default_site_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("DateTimePicker", {
                                    attrs: {
                                      type: "date",
                                      label: _vm.$t(
                                        "label_essweb_shift_form_effectiveDateLabel"
                                      ),
                                      defaultTime:
                                        _vm.shiftData.effective_utc_datetime,
                                      placeholder: "YYYY/MM/DD",
                                      max: _vm.shiftData.expired_utc_datetime,
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (time) {
                                        _vm.shiftData.effective_utc_datetime =
                                          time
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("DateTimePicker", {
                                    attrs: {
                                      min: _vm.shiftData.effective_utc_datetime,
                                      type: "date",
                                      label: _vm.$t(
                                        "label_essweb_shift_form_expireDateLabel"
                                      ),
                                      defaultTime:
                                        _vm.shiftData.expired_utc_datetime,
                                      placeholder: "YYYY/MM/DD",
                                    },
                                    on: {
                                      change: function (time) {
                                        _vm.shiftData.expired_utc_datetime =
                                          time
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_shift_form_timeZoneLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.staticZone,
                                      filled: "",
                                      "single-line": "",
                                      "menu-props": {
                                        offsetY: true,
                                        transition: "slide-y-transition",
                                        rounded: true,
                                        contentClass: "elevation-4",
                                      },
                                      "item-text": "text",
                                      "item-value": "utc",
                                      label: _vm.$t(
                                        "label_essweb_shift_form_timeZoneLabel"
                                      ),
                                      dense: "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.shiftData.expired_time_zone,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.shiftData,
                                          "expired_time_zone",
                                          $$v
                                        )
                                      },
                                      expression: "shiftData.expired_time_zone",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("AutoComplete", {
                                    attrs: {
                                      isRequired: "",
                                      items: _vm.ShiftPorpertyGroup,
                                      "item-text": "shift_property_group_name",
                                      "item-value": "uuid",
                                      label:
                                        "label_essweb_shift_form_shiftPropertyGroupLabel",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                      placeholder: _vm.$t(
                                        "label_essweb_shift_form_shiftPropertyGroupLabel"
                                      ),
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "selection",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item
                                                      .shift_property_group_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.title",
                                        fn: function (ref) {
                                          var data = ref.data
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    data.item
                                                      .shift_property_group_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value:
                                        _vm.shiftData.shift_property_group_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.shiftData,
                                          "shift_property_group_uuid",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "shiftData.shift_property_group_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-sheet",
                        {
                          staticClass:
                            "max-width pa-3 d-flex flex-row justify-space-between",
                          attrs: { height: "50" },
                        },
                        [
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_shift_form_step_punchMethodLabel"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("v-spacer"),
                          _c(
                            "div",
                            { staticClass: "text-right align-right" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "text-capitalize mx-2",
                                  attrs: {
                                    rounded: "",
                                    outlined: "",
                                    text: "",
                                    color: "primary",
                                  },
                                  on: { click: _vm.toCopyFromShift },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_shift_form_copyFromAnotherShift"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "text-capitalize mx-2",
                                  attrs: {
                                    rounded: "",
                                    outlined: "",
                                    text: "",
                                    color: "primary",
                                  },
                                  on: { click: _vm.toAddGroup },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "label_essweb_shift_form_addSiteBtnLabel"
                                      )
                                    )
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "material-icons-round" },
                                    [_vm._v("add")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.SiteMappingData.length == 0
                        ? _c("noContent")
                        : _vm._e(),
                      _vm._l(_vm.SiteMappingData, function (item, index) {
                        return _c("SpecialTable", {
                          key: index,
                          attrs: {
                            isHead: "",
                            headers: _vm.siteHeader,
                            showFooter: "",
                            tableTitle: item.site_name,
                            type: "site",
                            type_uuid: item.site_uuid,
                            items: item.items ? item.items : [],
                            newBtn: "label_essweb_shift_form_criteriaTypeLabel",
                          },
                          on: {
                            onNew: _vm.toAddCriteriaType,
                            onDelete: _vm.toDeleteCriteriaType,
                            onDeleteGroup: function ($event) {
                              return _vm.toDeleteGroup(item.site_uuid)
                            },
                          },
                        })
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: {
                newBtn:
                  _vm.stepper.length == _vm.curStep && _vm.curStep != 0
                    ? true
                    : false,
                step: _vm.stepper.length == _vm.curStep ? false : true,
                preStep: _vm.curStep > 1 ? true : false,
              },
              on: {
                next: _vm.toNext,
                pre: function ($event) {
                  _vm.curStep = _vm.curStep - 1
                },
                new: _vm.toNew,
                cancel: function ($event) {
                  return _vm.$toBack(_vm.isChanged)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("mapEventShift", {
              attrs: {
                show: _vm.mapToDialog,
                action: _vm.curAction,
                mapData: _vm.curMapData,
              },
              on: {
                closeDialog: function ($event) {
                  _vm.mapToDialog = false
                },
                new: _vm.onNewMapping,
                edit: _vm.onEditMapping,
              },
            }),
            _c("newGroupMapping", {
              attrs: { show: _vm.newGroupMapDialog },
              on: {
                new: _vm.toNewGroup,
                close: function ($event) {
                  _vm.newGroupMapDialog = false
                },
              },
            }),
            _c("newCriteriaTypeDialog", {
              attrs: { show: _vm.showCriteriaTypeDialog, site: _vm.curSite },
              on: {
                close: function ($event) {
                  _vm.showCriteriaTypeDialog = false
                },
                new: _vm.onNewCriteriaType,
              },
            }),
            _c("copyFromShift", {
              attrs: { show: _vm.showCopyShift, curentShift: "" },
              on: {
                close: function ($event) {
                  _vm.showCopyShift = false
                },
                new: _vm.onCopyFromShift,
              },
            }),
            _c("viewProperty", {
              attrs: {
                group_uuid: _vm.curGroupUuid,
                show: _vm.showPropertyList,
              },
              on: {
                close: function ($event) {
                  _vm.showPropertyList = false
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }